module.exports = __webpack_public_path__ + "img/jack.d3b1b366.png";